import {
  HOME_ENERGY_COST_ID,
  EV_ENERGY_COST_ID,
  GAS_ENERGY_COST_ID,
  HOME_ENERGY_CHART_COLOR,
  EV_ENERGY_CHART_COLOR,
  GAS_ENERGY_CHART_COLOR,
} from '../constants/';

const rateComparisonChartData = ({
  rateTotals,
  labelHome,
  labelElectric,
  labelGasoline,
}) => {
  return {
    datasets: [
      {
        label: labelHome,
        id: HOME_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[HOME_ENERGY_COST_ID]),
        backgroundColor: HOME_ENERGY_CHART_COLOR,
        barPercentage: 0.3,
        categoryPercentage: 0.7,
      },
      {
        label: labelElectric,
        id: EV_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[EV_ENERGY_COST_ID]),
        backgroundColor: EV_ENERGY_CHART_COLOR,
        barPercentage: 0.3,
        categoryPercentage: 0.7,
      },
      {
        label: labelGasoline,
        id: GAS_ENERGY_COST_ID,
        data: rateTotals.map((rateTotal) => rateTotal[GAS_ENERGY_COST_ID]),
        backgroundColor: GAS_ENERGY_CHART_COLOR,
        barPercentage: 0.3,
        categoryPercentage: 0.7,
      },
    ],
    labels: [...rateTotals.map((rate) => rate.title)],
    ids: [...rateTotals.map((rate) => rate.id)],
  };
};

export default rateComparisonChartData;
